import React, { Component, Fragment } from "react"
import "./pageNotFound.css"

class PageNotFound extends Component {
  state = {
    errorStatus: "",
    errorText: ""
  }
  componentWillMount() {
    if (this.props.error == 404) {
      this.setState({
        errorStatus: "404",
        errorText: "Sorry! Page not found"
      })
      setTimeout(() => {
        this.props.history.push("/")
      }, 2000)
    } else if (this.props.error == 500) {
      this.setState({
        errorStatus: "500",
        errorText: "Something went wrong"
      })
    }
  }

  render() {
    const { errorStatus, errorText } = this.state
    return (
      <Fragment>
        <div class="error">
          <div class="container-fluid">
            <div class="col-xs-12 ground-color text-center height-browser">
              <div class="container-error-404">
                <div class="clip">
                  <div class="shadow">
                    <span class="digit thirdDigit">{errorStatus[0]}</span>
                  </div>
                </div>
                <div class="clip">
                  <div class="shadow">
                    <span class="digit secondDigit">{errorStatus[1]}</span>
                  </div>
                </div>
                <div class="clip">
                  <div class="shadow">
                    <span class="digit firstDigit">{errorStatus[2]}</span>
                  </div>
                </div>
                <div class="msg">
                  OH!<span class="triangle"></span>
                </div>
              </div>
              <h2 class="h1">{errorText}</h2>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default PageNotFound


// WEBPACK FOOTER //
// ./src/pages/pageNotFound/page.js